import { memo } from 'react';
import cls from 'classnames';

import { useHuePointerStyles } from './styles';

function HuePointer() {
  const classes = useHuePointerStyles();

  return <div className={cls(classes.root, 'defaultHuePointer')} />;
}

export default memo(HuePointer);
